import { render, staticRenderFns } from "./RecentlyPlayed.vue?vue&type=template&id=3a399924&scoped=true&"
import script from "./RecentlyPlayed.vue?vue&type=script&lang=js&"
export * from "./RecentlyPlayed.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyPlayed.vue?vue&type=style&index=0&id=3a399924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a399924",
  null
  
)

export default component.exports